var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',[_c('AppHeader'),_c('router-view',{staticStyle:{"padding-top":"1px !important"}}),_c('AppTop'),_c('AppFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }